export default {
	yourTemples: "Tus Templos",
	createNew: "Crear nuevo templo",
	noTemple: "Ningún templo",
	createDialog: {
		title: "Crear Nuevo Templo",
		name: "Nombre del Templo",
		nameHint: "Inicial mayúscula en cada palabra (o todo en mayúsculas)",
		acronym: "Sigla",
		acronymHint: "2-10 caracteres en mayúsculas, solo letras y números. Se usará como identificador.",
		slugTaken: "Esta sigla ya está en uso. Elige otra.",
	},
	roles: {
		title: "Rol",
		owner: "Propietario",
		admin: "Administrador",
		member: "Miembro",
	},
	settings: "Configuraciones del Templo",
	publicAgenda: {
		navLabel: "Agenda pública",
		enableLabel: "Habilitar agenda pública",
		enableHint: "Publica una página con enlace único donde las personas ven los rituales y pueden reservar",
		linkLabel: "Enlace público",
		linkHint: "Comparte este enlace. Identifica tu templo de forma segura.",
		rotateLink: "Generar nuevo enlace",
		linkCopied: "¡Enlace copiado!",
		linkRotated: "Nuevo enlace generado. El anterior dejó de funcionar.",
		acceptReservations: "Aceptar reservas",
		acceptReservationsHint: "Permite que las personas reserven un lugar en los rituales publicados",
		requirePhone: "Exigir teléfono",
		requireEmail: "Exigir correo electrónico",
		requirePhoto: "Exigir foto",
		requirePhotoHint: "El consultante toma una foto (webcam) para completar la reserva.",
		seeNotifications: "Ver notificaciones de reserva",
		agendaWindowDays: "Ventana de la agenda (días)",
		agendaWindowDaysHint: "Cuántos días por delante mostrar rituales",
		welcomeText: "Descripción corta",
		welcomeTextHint: "Aparece en la parte superior de la página pública, debajo del nombre (opcional)",
		longDescription: "Descripción larga",
		longDescriptionHint: "Aparece en la pestaña “Más información” (opcional)",
		visibleFields: {
			title: "Mostrar en la página pública",
			hint: "Datos del registro de la casa. Solo aparece lo que esté marcado.",
			phone: "Teléfono",
			whatsapp: "WhatsApp",
			email: "Correo electrónico",
			address: "Dirección",
			instagram: "Instagram",
			facebook: "Facebook",
			notRegistered: "no registrado",
		},
		qrCode: "Código QR",
		rotateConfirm: {
			title: "¿Generar un nuevo enlace?",
			warning: "El enlace actual dejará de funcionar de inmediato. Quien ya tenga el enlace anterior no podrá acceder a la agenda.",
			instruction: "Para confirmar, escribe el código de abajo:",
			mismatch: "El código no coincide.",
			confirm: "Generar nuevo enlace",
		},
		qrDialog: {
			title: "Código QR de la agenda",
			hint: "Descárgalo o imprímelo para difundirlo. Al apuntar la cámara, se abre la agenda pública.",
			download: "Descargar",
			print: "Imprimir",
		},
	},
	settingsLabels: {
		defaultCountryCode: "Código de país predeterminado",
		defaultCountryCodeHint: "Aparece rellenado junto al teléfono en el registro.",
		templeData: "Datos del Templo",
		general: "General",
		contact: "Contacto",
		address: "Dirección",
		schedule: "Funcionamiento",
		visualIdentity: "Identidad Visual",
		printing: "Impresión",
		email: "Email",
		notifications: "Notificaciones",
		name: "Nombre del Templo",
		tradition: "Tradición",
		cnpj: "CNPJ",
		razaoSocial: "Razón Social",
		description: "Descripción",
		foundedAt: "Fecha de Fundación",
		phone: "Teléfono",
		whatsapp: "WhatsApp",
		templeEmail: "Email del Templo",
		instagram: "Instagram",
		facebook: "Facebook",
		saved: "¡Configuraciones guardadas con éxito!",
	},
	schedule: {
		title: "Días y Turnos de Funcionamiento",
		morning: "Mañana",
		afternoon: "Tarde",
		evening: "Noche",
		days: {
			mon: "Lunes",
			tue: "Martes",
			wed: "Miércoles",
			thu: "Jueves",
			fri: "Viernes",
			sat: "Sábado",
			sun: "Domingo",
		},
	},
	emailSettings: {
		sendReportOnClose: "Enviar informe al cerrar ritual",
		sendReportOnCloseHint: "Envía automáticamente el informe por email a administradores al cerrar un ritual",
		birthdayEmailEnabled: "Enviar email diario de cumpleañeros",
		birthdayEmailEnabledHint: "Envía un email por la mañana con la lista de cumpleañeros del día",
		birthdayRecipients: "Destinatarios",
		birthdayRecipientsHint: "Seleccione quién debe recibir el email de cumpleañeros",
		recipientAdmins: "Administradores",
		recipientAllUsers: "Todos los usuarios",
		recipientGuides: "Miembros de la corriente",
		receiptEmailEnabled: "Enviar recibo por email",
		receiptEmailEnabledHint: "Al registrar un pago, envía automáticamente el recibo por email al miembro (si tiene email registrado)",
	},
	attendanceTimeSettings: {
		title: "Atención",
		timeSectionTitle: "Tiempo de atención en las fichas",
		timeSectionDescription: "Controla los indicadores visuales de tiempo en la pantalla de llamada de fichas",
		warningMinutes: "Tiempo de alerta (amarillo)",
		warningMinutesHint: "La ficha se pone amarilla después de este tiempo (minutos)",
		limitMinutes: "Tiempo límite (rojo)",
		limitMinutesHint: "La ficha se pone roja después de este tiempo (minutos)",
	},
	financialSettings: {
		tabGeneral: "General",
		sectionTitle: "Cobros Automáticos",
		advanceDays: "Días de anticipación",
		advanceDaysHint: "Generar cobros {n} días antes del vencimiento (entre 5 y 25)",
		defaultDueDays: "Vencimiento predeterminado (días)",
		defaultDueDaysHint: "Un cobro abierto sin vencimiento se crea con {n} días de plazo desde hoy (entre 0 y 20; 0 = vence hoy)",
		sendPaymentReminders: "Enviar recordatorios de vencimiento",
		sendPaymentRemindersHint: "Envía un email de recordatorio 3 días antes del vencimiento",
		sendOverdueAlerts: "Enviar avisos de atraso",
		sendOverdueAlertsHint: "Envía un email de alerta 1 día después del vencimiento",
		allowEditAmountOnSettle: "Permitir editar el monto al dar de baja",
		allowEditAmountOnSettleHint: "Cuando está activado, el operador puede ajustar el monto al dar de baja un cobro o mensualidad. Desactivado, la baja salda por el monto exacto cobrado.",
		residualChargePolicy: "Cobro del saldo residual al editar el monto en la baja",
		residualChargePolicyHint: "Define qué ocurre con la diferencia cuando el monto pagado es menor que el cobrado: perdonarla, preguntar en cada baja, o generar automáticamente un cobro por el saldo restante.",
		residualChargePolicyOptions: {
			FORGIVE: "Desactivado — el saldo restante se perdona",
			ASK: "Preguntar en el momento de la baja",
			ALWAYS: "Cobrar siempre el saldo restante",
		},
	},
	whatsappSettings: {
		sectionTitle: "Alertas por WhatsApp",
		sectionDescription: "Mensajes enviados desde el número oficial de ORI, mencionando el nombre del templo.",
		enabled: "Activar alertas por WhatsApp",
		enabledHint: "Envía los avisos financieros también por WhatsApp, además del email",
		sendPaymentReminders: "Recordatorios de vencimiento",
		sendPaymentRemindersHint: "Envía un recordatorio por WhatsApp antes del vencimiento de los cobros",
		sendOverdueAlerts: "Avisos de atraso",
		sendOverdueAlertsHint: "Envía un aviso por WhatsApp cuando el cobro queda en atraso",
		sendPaymentConfirmations: "Confirmaciones de pago",
		sendPaymentConfirmationsHint: "Envía una confirmación por WhatsApp cuando se aprueba un pago",
		sendAdminAlerts: "Alertas para administradores",
		sendAdminAlertsHint: "Envía a los administradores avisos de pago recibido, gastos, duplicidad y cierre pendiente (cada admin debe activar WhatsApp en su propio perfil)",
		optInNote: "Cada persona recibe mensajes solo si tiene un teléfono válido y el consentimiento (opt-in) registrado en su ficha.",
	},
	notifications: {
		channelsTitle: "Canales de envío",
		channelsDescription: "Elige por qué canal se envía cada aviso. El email es el canal predeterminado; WhatsApp es un canal adicional.",
		emailChannel: "Email",
		emailChannelDesc: "Canal principal, siempre disponible para quienes tienen email registrado.",
		channelDefault: "Predeterminado",
		whatsappChannel: "WhatsApp",
		whatsappChannelDesc: "Mensajes enviados desde el número oficial de ORI, mencionando el nombre del templo.",
		whatsappOptInNote: "Cada persona recibe mensajes solo si tiene un teléfono válido y el consentimiento (opt-in) registrado en su ficha.",
		whatsappAddonChip: "Contratar add-on",
		whatsappAddonNote: "Las alertas por WhatsApp son un add-on y no están incluidas en tu plan actual. Contrata el add-on para activar este canal.",
		colEvent: "Evento",
		colEmail: "Email",
		colWhatsapp: "WhatsApp",
		sectionMember: "Cobros (para el miembro)",
		sectionAdmin: "Alertas para administradores",
		sectionReports: "Informes y relación",
		eventNewCharge: "Nuevo cobro generado",
		eventNewChargeHint: "Aviso enviado cuando se crea un nuevo cobro o mensualidad.",
		eventReminder: "Recordatorio de pago",
		eventReminderDaysPre: "Enviar",
		eventReminderDaysPost: "días antes del vencimiento (0 a 3; 0 = el mismo día)",
		eventOverdue: "Cobro en atraso",
		eventOverdueHint: "Aviso enviado el día siguiente al vencimiento.",
		eventConfirmation: "Pago confirmado / recibo",
		eventConfirmationHint: "Comprobante enviado cuando se aprueba el pago.",
		eventAdmin: "Alertas para la junta directiva",
		eventAdminHint: "Pago recibido, gastos por vencer/en atraso, duplicidad y cierre mensual pendiente.",
		eventClosingReport: "Informe de cierre mensual",
		eventClosingReportHint: "Enviado con el PDF al cerrar el mes.",
		eventBirthday: "Cumpleaños de miembro",
		eventBirthdayHint: "Lista de cumpleañeros del día, temprano por la mañana.",
		sectionReservations: "Agenda pública",
		eventNewReservation: "Nueva reserva",
		eventNewReservationHint: "Avisa a los administradores cuando una reserva pública se confirma y entra en la cola de revisión.",
		recipientsLabel: "Destinatarios:",
		footNote: "Los avisos esenciales (nuevo cobro, fallo de débito) siempre se envían cuando el canal está activo. WhatsApp requiere que la persona haya dado su opt-in.",
		alwaysTooltip: "Siempre enviado cuando el canal está activo",
		whatsappOffTooltip: "Activa el canal WhatsApp arriba",
		emailOnlyTooltip: "Disponible solo por email",
	},
	printing: {
		autoPrint: "Imprimir automáticamente al crear ficha",
		autoPrintHint: "Cuando está activado, la impresión se disparará cada vez que se cree una ficha durante el ritual",
		autoPrintScheduled: "Imprimir fichas de rituales agendados",
		autoPrintScheduledHint: "Cuando está activado, las fichas distribuidas en rituales futuros también se imprimirán automáticamente",
		paperWidth: "Ancho del papel",
		customMessage: "Mensaje personalizado",
		customMessageHint: "Texto mostrado al pie del comprobante (máx. 200 caracteres)",
		receiptEnabled: "Habilitar impresión de recibo",
		receiptEnabledHint: "Muestra el botón de imprimir recibo en los movimientos financieros pagados",
		showLogo: "Imprimir logotipo del templo en la ficha",
		showLogoHint: "Cuando está desactivado, la ficha se imprimirá sin el logotipo del templo",
		previewBeforePrint: "Ver el recibo antes de imprimir",
		previewBeforePrintHint: "Muestra el recibo en pantalla, con el botón de imprimir dentro, para comprobar nombre, importe y fecha antes de gastar papel. Desactivado, imprime directamente.",
		previewReceiptTitle: "Recibo",
		previewHint: "Compruébelo antes de gastar papel.",
		previewPrint: "Imprimir",
		previewPrintFailed: "No se pudo abrir la impresión. Inténtelo de nuevo.",
		kioskManualHint: "Para configurar la impresión silenciosa, consulte el",
		kioskManualLink: "manual de impresión",
		testPrint: "Imprimir página de prueba",
	},
	pixSettings: {
		disabledByMp: "Con la integración de Mercado Pago activa, esta función está deshabilitada — los cobros usan el PIX dinámico de Mercado Pago.",
		enabled: "Incluir código QR PIX en los correos de cobro",
		enabledHint: "Cuando está activado, los correos de recordatorio y atraso incluirán un código QR PIX con el valor completado",
		sectionDescription: "Configure la clave PIX que se usará para generar el código QR.",
		keyType: "Tipo de clave PIX",
		key: "Clave PIX",
		keyHint: "CPF, CNPJ, correo, teléfono o clave aleatoria",
		keyTypeRequired: "Elija el tipo de clave antes de informar la clave PIX",
		keyInvalid: {
			CPF: "CPF inválido — verifique los 11 dígitos",
			CNPJ: "CNPJ inválido — verifique los 14 dígitos",
			EMAIL: "Correo inválido o demasiado largo (máx. 77 caracteres)",
			PHONE: "Teléfono inválido — informe el código de área y el número, de un teléfono de Brasil",
			RANDOM: "Clave aleatoria inválida — son 36 caracteres con guiones, exactamente como la entregó el banco",
		},
		recipientName: "Nombre del beneficiario",
		recipientNameHint: "Nombre que aparecerá en el PIX (máx. 25 caracteres)",
		city: "Ciudad",
		cityHint: "Ciudad del beneficiario (máx. 15 caracteres)",
	},
	preSenhaSettings: {
		usePreSenha: "Usar pre-turno en la atención",
		usePreSenhaHint: "Activa el sistema de llamada por pre-turno en la página de distribución de fichas",
	},
	invites: "Invitaciones",
	pendingInvites: "Invitaciones Pendientes",
	noInvites: "Sin invitaciones pendientes",
	inviteCode: "Código de Invitación",
	inviteCodeDescription: "Comparte este código para invitar miembros",
	generateCode: "Generar Código",
	revokeCode: "Revocar Código",
	codeExpires: "Expira en",
	copyCode: "Copiar código",
	codeCopied: "¡Código copiado!",
	inviteByEmail: "Invitar por Email",
	sendInvite: "Enviar Invitación",
	email: "Email del invitado",
	role: "Rol",
	ritualFunction: "Función Ritual",
	ritualFunctionHint: "Ej: Médium, Cambono, Ogã (opcional)",
	inviteSent: "¡Invitación enviada con éxito!",
	inviteRevoked: "Invitación revocada",
	expired: "Expirado",
	pending: "Pendiente",
};
